export function Divider() {
  return <hr className="border-spark-border-subtle" />;
}
